import { AApi } from './AApi';
import type { ApiResult } from '../types/api.types';
import type { EmailTestBody, EmailTestInput, EmailTestResultBody } from '../types/emailTest.types';

/** The test mails of the root area. */
export class EmailTestApi extends AApi {
    /** GET — the SMTP settings and the cooldown. */
    public getEmailTest(): Promise<ApiResult<EmailTestBody>> {
        return this.Client.get(`${this.VersionPath}/emailTest`);
    }

    /** POST — a test mail to a user or to each user of a team. */
    public sendEmailTest(input: EmailTestInput): Promise<ApiResult<EmailTestResultBody>> {
        return this.Client.post(`${this.VersionPath}/emailTest`, input);
    }
}
